import { render, staticRenderFns } from "./user_avatar_link.vue?vue&type=template&id=fe92f292&vue3"
import script from "./user_avatar_link.vue?vue&type=script&lang=js&vue3"
export * from "./user_avatar_link.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports